import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  type?: 'error' | 'success' | 'warning' | 'info';
}

const TONE: Record<
  NonNullable<AlertModalProps['type']>,
  { color: 'error' | 'success' | 'warning' | 'info'; title: string; badge: string }
> = {
  error: { color: 'error', title: 'Erro', badge: 'Erro' },
  success: { color: 'success', title: 'Sucesso', badge: 'Ok' },
  warning: { color: 'warning', title: 'Atenção', badge: 'Atenção' },
  info: { color: 'info', title: 'Informação', badge: 'Info' },
};

const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'error',
}) => {
  const tone = TONE[type];

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      role="alertdialog"
      aria-labelledby="alert-modal-title"
      aria-describedby="alert-modal-message"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="alert-modal-title" sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Chip label={tone.badge} color={tone.color} size="small" />
          <Box component="span" sx={{ fontWeight: 700 }}>
            {title || tone.title}
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-modal-message" sx={{ color: 'text.primary' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" color="primary" onClick={onClose} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertModal;
